// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"
import type { DataReceivedType, DataType } from "../../types"

// Utils
import { useApi } from "utils"
import { useDetail } from "./useDetail"

export function useReceivedDetail(received_reject_id: number): {
  rejectData: DataType | null
  data: DataReceivedType | null
  isLoading: boolean
} {
  // Hooks
  const api = useApi()
  const detail = useDetail()
  const [data, setData] = useState<DataReceivedType | null>(null)
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get(
      "/proreject/detail_received_reject",
      { params: { received_reject_id } }
    ).then((res: SuccessFetch<{
      payload: {
        approve_status: number
        approve_by: string | null
        detail: {
          discount: string
          price_received: string
          product_id: number
          qty_received_item: string
          qty_unit: string
          tax_id: number
          tax_rate: string
          total: string
          total_tax_paid: string
        }[]
        reject_id: number
        trx_code: string
        vendor_id: number
        location_id: number
        address: string
        memo: string
        referensi: string
        transaction_date: string
      }
    }>) => {
      // Vars
      const payload = res.data.payload
      const reject_id = payload.reject_id

      detail.fetchData(reject_id)
      setData({
        reject_id,
        address: payload.address,
        approve_by: payload.approve_by ?? "-",
        approve_status: payload.approve_status,
        location_id: payload.location_id,
        memo: payload.memo,
        referensi: payload.referensi,
        trx_code: payload.trx_code,
        vendor_id: payload.vendor_id,
        transaction_date: payload.transaction_date,
        detail: payload.detail.map(item => ({
          qty_back_delivered: 0,
          unit_measure: "-",
          discount: parseInt(item.discount),
          price_received: parseInt(item.price_received),
          product_id: item.product_id,
          qty_received_item: parseInt(item.qty_received_item),
          qty_unit: parseInt(item.qty_unit),
          tax_id: item.tax_id,
          tax_rate: parseInt(item.tax_rate),
          total: parseInt(item.total),
          total_tax_paid: parseInt(item.total_tax_paid)
        }))
      })
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setTimeout(() => {
        setLoading(false)
      }, 500)
    })

    // eslint-disable-next-line
  }, [])

  return {
    data,
    isLoading: isLoading || detail.isLoading,
    rejectData: detail.data
  }
}